export function generateResourceVersion(): number {
  const TICKS_AT_EPOCH = 621355968000000000n // Ticks at Unix epoch (1970-01-01T00:00:00Z)
  const TICKS_PER_MILLISECOND = 10000 // Number of ticks per millisecond

  const now = new Date()
  const ticksSinceEpoch = now.getTime() * TICKS_PER_MILLISECOND

  return Number(TICKS_AT_EPOCH) + ticksSinceEpoch
}
